export class AppEvent {
  constructor(eventType) {
    this.ts = new Date();
    this.user_id = '';
    this.et = eventType;
    this.ed = 'APP';
    this.app = 'ASSESSMENT';
  }

  toString() {
    return JSON.stringify(this);
  }
}

export class PageViewed extends AppEvent {
  constructor(pagename, referrer, context = {}) {
    super('PageViewed');

    this.pagename = pagename;
    this.referrer = referrer;
    this.context = context;
  }
}
export class ErrorMsg extends AppEvent {
  constructor(pagename, typeOfError, context = {}) {
    super('ErrorMsg');

    this.pagename = pagename;
    this.typeOfError = typeOfError;
    this.context = context;
  }
}
export class ItemSearched extends AppEvent {
  constructor(pagename, caseId, context = {}) {
    super('ItemSearched');

    this.pagename = pagename;
    this.caseId = caseId;
    this.context = context;
  }
}
export class PillClicked extends AppEvent {
  constructor(pagename, caseId, context = {}) {
    super('PillClicked');

    this.pagename = pagename;
    this.caseId = caseId;
    this.context = context;
  }
}

export class PageScrolled extends AppEvent {
  constructor(pagename, direction, context = {}) {
    super('PageScrolled');

    this.pagename = pagename;
    this.direction = direction;
    this.context = context;
  }
}
export class HorizontalScroll extends AppEvent {
  constructor(pagename, context = {}) {
    super('HorizontalScroll');

    this.pagename = pagename;
    this.context = context;
  }
}
export class BannerClicked extends AppEvent {
  constructor(pagename, context = {}) {
    super('BannerClicked');

    this.pagename = pagename;
    this.context = context;
  }
}
export class PopupOpened extends AppEvent {
  constructor(pagename, popupName, context = {}) {
    super('PopupOpened');

    this.pagename = pagename;
    this.popupName = popupName;
    this.context = context;
  }
}
export class PopupClosed extends AppEvent {
  constructor(pagename, popupName, context = {}) {
    super('PopupClosed');

    this.pagename = pagename;
    this.popupName = popupName;
    this.context = context;
  }
}
export class ButtonClicked extends AppEvent {
  constructor(btnName, context = {}, referrer, pagename) {
    super('ButtonClicked');

    this.referrer = referrer;
    this.pagename = pagename;
    this.buttonName = btnName;
    this.context = context;
  }
}

export class MetaValueUpdated extends AppEvent {
  constructor(name, metaId, caseId, isSymptom, pagename, referrer, context = {}) {
    super('MetaValueUpdated');

    this.isSymptom = isSymptom;
    this.metaId = metaId;

    this.pagename = pagename;
    this.referrer = referrer;
    this.name = name;
    this.caseId = caseId;
  }
}
